import React, {memo, useEffect} from "react";
import BaseModal from "../BaseModal";
import {useDispatch, useSelector} from "react-redux";
import {Button, Col, Modal, Row, Form} from "react-bootstrap";
import NumericInput from 'react-numeric-input';
import {IMG_PRODUCTS_PUBLIC_URL_SERVER, PUBLIC_URL_SERVER} from "../../../../../apis";
import imgPlayS from "../../../../../images/base-image-product.jpg";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {
    actionChangeInputNumberModalProduct, actionChangeItemOptions,
    handelChangeSelectGradeModalProduct,
    handelCloseModalProduct
} from "../../../../../redux/actions/modals/ModalProduct";
import TitlesModals from "../TitlesModals";
import {actionAddItemInSHoppingCard, actionRemoveItemInBasketCart} from "../../../../../redux/actions/modals/modalShoppingCard";
import {toast} from "react-toastify";
import Swal from 'sweetalert2';
import LoaderModals from "../../loaders/LoaderModals";

// import Swiper core and required components
import SwiperCore, {Navigation, Scrollbar, A11y, Pagination} from 'swiper';

import {Swiper, SwiperSlide} from 'swiper/react';
import CardProduct from "../../card/CardProduct";
import {FaAngleDoubleLeft, FaInfoCircle, FaPlus, FaTrashAlt} from "react-icons/all";

import {actionChangeEvent} from "../../../../../redux/actions/googleAnalytics";

// install Swiper components
SwiperCore.use([Navigation, Scrollbar, A11y, Pagination]);

const ModalProduct = () => {
    const dispatch = useDispatch();
    const {
        statusShow,
        data,
        selectGrade,
        similar,
        numberInput,
        loader,
        options
    } = useSelector(state => state.modalProduct);
    const {carts} = useSelector(state => state.shoppingCart);
    const {name, images, grades, description} = data;


    useEffect(() => {
        if(name !== null && name !== undefined && name !== '')
            dispatch(actionChangeEvent("product_open", {name: name}));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [name]);

    const handleClose = () => {
        dispatch(handelCloseModalProduct());
    };

    const handelChangeInputNumbers = (event) => {
        dispatch(actionChangeInputNumberModalProduct(event));
    };

    const settingSwiper = {
        slidesPerView: 2.5,
        spaceBetween: 0,
        loop: false,
        freeMode: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            0: {
                slidesPerView: 2.5,
            },
            567: {
                slidesPerView: 2,
            }
        }
    }

    const handelChangeSelectGrades = (event) => {
        
        const {value} = event.target;
        const grade = grades.filter((item) => {
            return item.gradeId === value;
        })
        if (carts.length > 0)
            for (const cart in carts) {
                if (carts[cart].grades[0].gradeId === grade[0].gradeId) {
                    dispatch(handelChangeSelectGradeModalProduct(
                        {...grade[0], number_input: carts[cart].w_numbers}, carts[cart].optionSelect));
                    break;
                } else {
                    dispatch(handelChangeSelectGradeModalProduct(grade[0]));
                }
            }
        else {
            dispatch(handelChangeSelectGradeModalProduct(grade[0]));
        }
    };

    const handelAddToShoppingCard = () => {
        if (numberInput > 0) {
            toast.success(`${numberInput} ${selectGrade.unit} ${data.name} به سبد خرید اضافه شد`, {
                position: toast.POSITION.BOTTOM_CENTER
            });
            let optionSelect = null;
            for (const option in options) {
                if (options[option].default === "1") {
                    optionSelect = options[option];
                }
            }
            dispatch(actionAddItemInSHoppingCard(data, selectGrade, numberInput, optionSelect));
            handleClose();
        } else {
            toast.success(`${data.name} از سبد خرید حذف شد`, {
                position: toast.POSITION.BOTTOM_CENTER
            });
            dispatch(actionRemoveItemInBasketCart(selectGrade.gradeId));
            handleClose();

            // swal({
            //     title: "خطا",
            //     text: "مقدار نمیتواند صفر باشد.",
            //     buttons: {
            //         cancel: "تایید",
            //     },
            //     icon: "error",
            // });
        }
    };

    const handelChangeOptionsModalProduct = (event) => {
        const {name, value} = event.target;
        dispatch(actionChangeItemOptions(name, value));
    };

    const handleOpenDescription = () => {
        const btnOkSingle = Swal.mixin({
            customClass: {
                confirmButton: 'base-btn-green-border btn btn-success',
            },
            buttonsStyling: false
        });
        btnOkSingle.fire({
            text: description,
            imageUrl: PUBLIC_URL_SERVER + '/icons/fm_logo_ofoghi_new.png',
            imageHeight: 45,
            imageAlt: 'فروت مروت',
            confirmButtonText: "تایید",
        });
    }

    return (
        <BaseModal title={''}
                   show={statusShow}
                   dialogClassName={''}
                   handleClose={handleClose}>
            <Modal.Body>
                {!loader ?
                    <React.Fragment>
                        <div className={'text-center'}>
                            <div>
                                {images && Object.keys(images).length > 0 ?
                                    Object.keys(images).length === 1
                                        ?
                                        <LazyLoadImage
                                            alt={name}
                                            height={340}
                                            src={PUBLIC_URL_SERVER + IMG_PRODUCTS_PUBLIC_URL_SERVER + images[0]} // use normal <img> attributes as props
                                            width={340}
                                            placeholderSrc={imgPlayS}
                                        />
                                        :
                                        <Swiper
                                            spaceBetween={0}
                                            slidesPerView={1}
                                            pagination={{clickable: true}}
                                        >
                                            {Object.keys(images).map(imageKey => (
                                                <SwiperSlide key={imageKey}>
                                                    <LazyLoadImage
                                                        alt={name}
                                                        height={340}
                                                        src={PUBLIC_URL_SERVER + IMG_PRODUCTS_PUBLIC_URL_SERVER + images[imageKey]} // use normal <img> attributes as props
                                                        width={340}
                                                        placeholderSrc={imgPlayS}
                                                    />
                                                </SwiperSlide>
                                            ))}
                                        </Swiper>
                                    : null}
                            </div>
                            <div>
                                <div className={'mt-2'}>
                                    <h6>
                                        <span>{name}</span>
                                        {description &&
                                        <FaInfoCircle className='text-danger' onClick={handleOpenDescription}/>}
                                    </h6>
                                </div>
                                {(typeof grades !== "undefined" && grades.length) > 1 ?
                                    <Form.Group className={'d-inline-block'}>
                                        <Form.Control as="select" onChange={handelChangeSelectGrades}
                                                      defaultValue={selectGrade.gradeId}>
                                            {grades.map(item =>
                                                <option key={item.gradeId} value={item.gradeId}>
                                                    {item.gradeTitle + ' ' + item.ourPrice + ' تومان '}
                                                </option>)}
                                        </Form.Control>
                                    </Form.Group>
                                    :
                                    <div className={'mt-3'}>
                                        <span>{selectGrade.gradeTitle}</span>
                                    </div>
                                }

                                {
                                    options.length > 0 ?
                                        <div className={'mt-3'}>
                                            <div className={'list-options-items-product'}>
                                                {
                                                    options.map((item, index) => (
                                                        <div key={index}>
                                                            <input value={item.id}
                                                                   id={`item-radio-options-product-${index}`}
                                                                   onChange={handelChangeOptionsModalProduct}
                                                                   type={"radio"} name={'options'}
                                                                   checked={item.default === "1"}/>
                                                            <label className={'item-options-product'}
                                                                   htmlFor={`item-radio-options-product-${index}`}>
                                                                {item.title}
                                                            </label>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        </div>
                                        : ''
                                }
                                <div className={'mt-3'}>
                                    <span>هر </span>
                                    <span>{selectGrade.unit}</span>
                                    <span
                                        className={'mr-2 ml-2'}>{parseInt(selectGrade.ourPrice) !== 0 ? parseInt(selectGrade.ourPrice).toLocaleString() : ' رایگان '}</span>
                                    {parseInt(selectGrade.ourPrice) !== 0 ?
                                        <span className={'mr-2 ml-2'}>تومان</span>
                                        : ''
                                    }
                                </div>
                            </div>
                            <div className={'mt-3'}>
                                <Row className={'justify-content-center w-100 m-0'}>
                                    <Col xs={{span: 7, order: 1}} sm={5} className={'mt-2'}>
                                        <Button variant="success"
                                                className={'base-btn-green btn-add-basket-shopping-card'}
                                                block onClick={handelAddToShoppingCard}>
                                            {numberInput === 0 ?
                                                <FaTrashAlt style={{marginBottom: "4px"}}/>
                                                : <FaPlus style={{marginBottom: "4px"}}/>
                                            }
                                            <span> 
                                            {numberInput === 0 ?
                                                'حذف از سبد خرید'
                                                : 'افزودن به سبد خرید'
                                            }
                                            </span>
                                        </Button>
                                    </Col>
                                    <Col xs={7} sm={5} className={'mt-2'}>
                                        <NumericInput
                                            className="form-control cm-react-numeric-input"
                                            value={numberInput}
                                            format={(num) => (num + `  ${selectGrade.unit}`)}
                                            step={(component, direction) => {
                                                switch (direction) {
                                                    case "up":
                                                        handelChangeInputNumbers('up');
                                                        break;
                                                    case "down":
                                                        handelChangeInputNumbers('down');
                                                        break;
                                                    default:
                                                }
                                            }}
                                            size={5}
                                            mobile
                                            onChange={handelChangeInputNumbers}
                                            max={100}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        </div>
                        <div className={'base-more-products-modal-product'}>
                            <div className={'title-more-products-modal-product'}>
                                <TitlesModals>
                                    <FaAngleDoubleLeft className={'mr-2'}/>
                                    <span>محصول های مشابه</span>
                                </TitlesModals>
                            </div>
                            <Row className={'w-100 m-auto'}>
                                <Col>
                                    {similar.length > 0 ?
                                        <div className={'more-products-modal-product mb-2'} dir={"ltr"}>
                                            <Swiper {...settingSwiper}>
                                                {similar.map((item) => <SwiperSlide key={item.id}><CardProduct
                                                    product={item}/></SwiperSlide>)}
                                                <div className="swiper-button-prev swiper-button-custom"/>
                                                <div className="swiper-button-next swiper-button-custom"/>
                                            </Swiper>
                                        </div>
                                        : <div className={'text-center mt-3'}>مورد مشابهی یافت نشد</div>
                                    }
                                </Col>
                            </Row>
                        </div>
                    </React.Fragment>
                    : <LoaderModals/>}

            </Modal.Body>
        </BaseModal>
    );
};

export default memo(ModalProduct);
